export default (resp, noJson) => {
  if (!resp.ok) throw resp;
  if (noJson) return resp;
  return resp.json();
};
